import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';

export function useGetChildProjectsGq(command: CommandGq) {
  const query = useCustomQuery<ResponseGq, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  return {
    query,
    data: (query?.data ?? query?.previousData)?.projects?.getChildProjects,
  };
}

const gqTag = gql`
  query GetChildProjects($command: GetChildProjectsCommand!) {
    projects {
      getChildProjects(command: $command) {
        childProjects {
          id
          name
          clientName
          clientDomain
          location
          language
          currency
          keywords
          serpKeywords
        }
      }
    }
  }
`;

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  parentId?: number;
  childProjectIds?: number[];
}

export interface GetProjectsCommandGq extends CommandGq {}

export interface ResponseGq {
  readonly projects: {
    readonly getChildProjects: {
      readonly childProjects: AnalyzedChildProjectGq[];
    };
  };
}

export interface AnalyzedChildProjectGq {
  readonly id: number;
  readonly name: string;
  readonly clientName: string;
  readonly clientDomain: string;
  readonly location: string;
  readonly language: string;
  readonly currency: string;
  readonly keywords: number;
  readonly serpKeywords: number;
}
